export default __webpack_public_path__ + "img/intro-mobile-step2.jpg";